<div class="pdf-viewer-container" role="main" aria-label="PDF Document Viewer">
  <!-- Snap Zones -->
  <div class="snap-zone snap-zone-left"
       [class.near]="isNearLeftZone"
       [class.active]="isInLeftZone"
       role="none">
  </div>
  <div class="snap-zone snap-zone-right"
       [class.near]="isNearRightZone"
       [class.active]="isInRightZone"
       role="none">
  </div>

  <div *ngIf="loading" class="loading-spinner" role="status" aria-live="polite">
    <mat-spinner diameter="50" aria-label="Loading PDF document"></mat-spinner>
    <p>Loading PDF...</p>
  </div>

  <div class="pdf-content" *ngIf="!loading && pdfSrc" role="document"
       [attr.aria-label]="'PDF document, page ' + currentPage + ' of ' + totalPages">
    <pdf-viewer
      [src]="pdfSrc"
      [render-text]="true"
      [original-size]="false"
      [show-all]="true"
      [fit-to-page]="true"
      [zoom]="zoom"
      [(page)]="currentPage"
      (after-load-complete)="onPagesLoaded($event)"
      (page-change)="onPageChange($event)"
      style="width: 100%; height: 100%;"
      aria-label="PDF document viewer">
    </pdf-viewer>
  </div>

  <div *ngIf="!loading && !pdfSrc" class="error-message" role="alert" aria-live="assertive">
    <p>Error loading PDF. Please try again later.</p>
  </div>

  <!-- Floating Dock -->
  <div class="floating-dock" *ngIf="!loading && pdfSrc"
       cdkDrag
       [cdkDragBoundary]="'.pdf-viewer-container'"
       [cdkDragFreeDragPosition]="dockPosition"
       (cdkDragEnded)="onDragEnded($event)"
       (cdkDragMoved)="onDragMoved($event)"
       [class.snapped-left]="isSnappedLeft"
       [class.snapped-right]="isSnappedRight"
       [class.expanded]="isDockExpanded"
       role="toolbar"
       aria-label="PDF viewer controls"
       [attr.aria-expanded]="isDockExpanded">

    <div class="mobile-toggle"
         (click)="toggleDockExpansion($event)"
         role="button"
         [attr.aria-label]="isDockExpanded ? 'Collapse controls' : 'Expand controls'"
         [attr.aria-expanded]="isDockExpanded"
         tabindex="0"
         (keydown.enter)="toggleDockExpansion($event)"
         (keydown.space)="toggleDockExpansion($event)">
      <svg *ngIf="!isDockExpanded" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path d="M4 6H20M4 12H20M4 18H20" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
      <svg *ngIf="isDockExpanded" width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
        <path d="M6 18L18 6M6 6L18 18" stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </div>

    <ng-container *ngIf="!isSnappedLeft && !isSnappedRight">
      <div class="dock-handle dock-handle-left" cdkDragHandle
           role="button"
           aria-label="Drag handle"
           tabindex="0">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
          <path d="M12 6L12 18M8 6L8 18M16 6L16 18" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
    </ng-container>

    <div class="dock-controls" role="group" aria-label="PDF controls">
      <!-- Zoom Controls -->
      <div class="control-group" role="group" aria-label="Zoom controls">
        <button mat-icon-button
                (click)="zoomOut()"
                [attr.aria-label]="'Zoom out (current zoom: ' + (zoom * 100).toFixed(0) + '%)'"
                [attr.title]="'Zoom out (current zoom: ' + (zoom * 100).toFixed(0) + '%)'"
                [disabled]="zoom <= 0.5">
          <svg width="800px" height="800px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">

            <title>zoom-out</title>
            <desc>Created with Sketch Beta.</desc>
            <defs>

            </defs>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
              <g id="Icon-Set" sketch:type="MSLayerGroup" transform="translate(-360.000000, -1139.000000)"
                fill="#fff">
                <path
                  d="M373.46,1163.45 C367.17,1163.45 362.071,1158.44 362.071,1152.25 C362.071,1146.06 367.17,1141.04 373.46,1141.04 C379.75,1141.04 384.85,1146.06 384.85,1152.25 C384.85,1158.44 379.75,1163.45 373.46,1163.45 L373.46,1163.45 Z M391.688,1169.25 L383.429,1161.12 C385.592,1158.77 386.92,1155.67 386.92,1152.25 C386.92,1144.93 380.894,1139 373.46,1139 C366.026,1139 360,1144.93 360,1152.25 C360,1159.56 366.026,1165.49 373.46,1165.49 C376.672,1165.49 379.618,1164.38 381.932,1162.53 L390.225,1170.69 C390.629,1171.09 391.284,1171.09 391.688,1170.69 C392.093,1170.3 392.093,1169.65 391.688,1169.25 L391.688,1169.25 Z M378.689,1151.41 L368.643,1151.41 C368.102,1151.41 367.663,1151.84 367.663,1152.37 C367.663,1152.9 368.102,1153.33 368.643,1153.33 L378.689,1153.33 C379.23,1153.33 379.669,1152.9 379.669,1152.37 C379.669,1151.84 379.23,1151.41 378.689,1151.41 L378.689,1151.41 Z"
                  id="zoom-out" sketch:type="MSShapeGroup">

                </path>
              </g>
            </g>
          </svg>
        </button>
        <span class="zoom-value" role="status" aria-live="polite" aria-label="Current zoom level">
          {{ (zoom * 100).toFixed(0) }}%
        </span>
        <button mat-icon-button
                (click)="zoomIn()"
                [attr.aria-label]="'Zoom in (current zoom: ' + (zoom * 100).toFixed(0) + '%)'"
                [attr.title]="'Zoom in (current zoom: ' + (zoom * 100).toFixed(0) + '%)'"
                [disabled]="zoom >= 3">
          <svg width="800px" height="800px" viewBox="0 0 32 32" version="1.1" xmlns="http://www.w3.org/2000/svg"
            xmlns:xlink="http://www.w3.org/1999/xlink" xmlns:sketch="http://www.bohemiancoding.com/sketch/ns">

            <title>zoom-in</title>
            <desc>Created with Sketch Beta.</desc>
            <defs>

            </defs>
            <g id="Page-1" stroke="none" stroke-width="1" fill="none" fill-rule="evenodd" sketch:type="MSPage">
              <g id="Icon-Set" sketch:type="MSLayerGroup" transform="translate(-308.000000, -1139.000000)"
                fill="#fff">
                <path
                  d="M321.46,1163.45 C315.17,1163.45 310.07,1158.44 310.07,1152.25 C310.07,1146.06 315.17,1141.04 321.46,1141.04 C327.75,1141.04 332.85,1146.06 332.85,1152.25 C332.85,1158.44 327.75,1163.45 321.46,1163.45 L321.46,1163.45 Z M339.688,1169.25 L331.429,1161.12 C333.592,1158.77 334.92,1155.67 334.92,1152.25 C334.92,1144.93 328.894,1139 321.46,1139 C314.026,1139 308,1144.93 308,1152.25 C308,1159.56 314.026,1165.49 321.46,1165.49 C324.672,1165.49 327.618,1164.38 329.932,1162.53 L338.225,1170.69 C338.629,1171.09 339.284,1171.09 339.688,1170.69 C340.093,1170.3 340.093,1169.65 339.688,1169.25 L339.688,1169.25 Z M326.519,1151.41 L322.522,1151.41 L322.522,1147.41 C322.522,1146.85 322.075,1146.41 321.523,1146.41 C320.972,1146.41 320.524,1146.85 320.524,1147.41 L320.524,1151.41 L316.529,1151.41 C315.978,1151.41 315.53,1151.59 315.53,1152.14 C315.53,1152.7 315.978,1153.41 316.529,1153.41 L320.524,1153.41 L320.524,1157.41 C320.524,1157.97 320.972,1158.41 321.523,1158.41 C322.075,1158.41 322.522,1157.97 322.522,1157.41 L322.522,1153.41 L326.519,1153.41 C327.07,1153.41 327.518,1152.96 327.518,1152.41 C327.518,1151.86 327.07,1151.41 326.519,1151.41 L326.519,1151.41 Z"
                  id="zoom-in" sketch:type="MSShapeGroup">

                </path>
              </g>
            </g>
          </svg>
        </button>
        <button mat-icon-button
                (click)="resetZoom()"
                aria-label="Reset zoom to 100%"
                title="Reset zoom to 100%">
          <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
            <title>Reset zoom</title>
            <path d="M4 15V18C4 19.1046 4.89543 20 6 20H9M15.2173 20H18C19.1046 20 20 19.1046 20 18V15M20 9V6C20 4.89543 19.1046 4 18 4H15M4 9V6C4 4.89543 4.89543 4 6 4H9"
              stroke="#fff" stroke-width="2" stroke-linecap="round" stroke-linejoin="round" />
          </svg>
        </button>
      </div>

      <!-- Page Navigation -->
      <div class="control-group" role="group" aria-label="Page navigation">
        <button mat-icon-button
                (click)="previousPage()"
                class="previous-page-button"
                [disabled]="currentPage === 1"
                aria-label="Previous page"
                [attr.title]="'Go to previous page (current page: ' + currentPage + ')'"
                [attr.aria-disabled]="currentPage === 1"
                tabindex="0">
          <svg width="800px" height="800px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
            <title>Previous page</title>
            <path class="cls-1" fill="#fff" d="M22,29.73a1,1,0,0,1-.71-.29L9.93,18.12a3,3,0,0,1,0-4.24L21.24,2.56A1,1,0,1,1,22.66,4L11.34,15.29a1,1,0,0,0,0,1.42L22.66,28a1,1,0,0,1,0,1.42A1,1,0,0,1,22,29.73Z" />
          </svg>
        </button>
        <span class="page-info" role="group" aria-label="Page navigation input">
          <label for="pageInput" class="sr-only">Go to page</label>
          <input type="number"
                 id="pageInput"
                 [value]="currentPage"
                 (change)="goToPage($any($event.target).value)"
                 min="1"
                 [max]="totalPages"
                 class="page-input"
                 [attr.aria-label]="'Enter page number (1 to ' + totalPages + ')'"
                 [attr.aria-valuemin]="1"
                 [attr.aria-valuemax]="totalPages"
                 [attr.aria-valuenow]="currentPage"
                 role="spinbutton"> / {{ totalPages }}
        </span>
        <button mat-icon-button
                (click)="nextPage()"
                class="next-page-button"
                [disabled]="currentPage === totalPages"
                aria-label="Next page"
                [attr.title]="'Go to next page (current page: ' + currentPage + ')'"
                [attr.aria-disabled]="currentPage === totalPages">
          <svg width="800px" height="800px" viewBox="0 0 32 32" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
            <title>Next page</title>
            <path class="cls-1" fill="#fff" d="M10.05,29.73a1,1,0,0,1-.71-.29,1,1,0,0,1,0-1.42L20.66,16.71a1,1,0,0,0,0-1.42L9.34,4a1,1,0,0,1,1.42-1.42L22.07,13.88a3,3,0,0,1,0,4.24L10.76,29.44A1,1,0,0,1,10.05,29.73Z" />
          </svg>
        </button>
      </div>

      <!-- Download Button -->
      <div class="control-group" role="group" aria-label="Download controls">
        <button mat-icon-button
                (click)="downloadPdf()"
                aria-label="Download PDF document"
                title="Download PDF document">
          <svg width="800px" height="800px" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
            <title>Download document</title>
            <path d="M8 22.0002H16C18.8284 22.0002 20.2426 22.0002 21.1213 21.1215C22 20.2429 22 18.8286 22 16.0002V15.0002C22 12.1718 22 10.7576 21.1213 9.8789C20.3529 9.11051 19.175 9.01406 17 9.00195M7 9.00195C4.82497 9.01406 3.64706 9.11051 2.87868 9.87889C2 10.7576 2 12.1718 2 15.0002L2 16.0002C2 18.8286 2 20.2429 2.87868 21.1215C3.17848 21.4213 3.54062 21.6188 4 21.749"
              stroke="#fff" stroke-width="1.5" stroke-linecap="round" />
            <path d="M12 2L12 15M12 15L9 11.5M12 15L15 11.5" stroke="#fff" stroke-width="1.5" stroke-linecap="round"
              stroke-linejoin="round" />
          </svg>
        </button>
      </div>
    </div>

    <ng-container *ngIf="!isSnappedLeft && !isSnappedRight">
      <div class="dock-handle dock-handle-right" cdkDragHandle
           role="button"
           aria-label="Drag handle"
           tabindex="0">
        <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true" focusable="false">
          <path d="M12 6L12 18M8 6L8 18M16 6L16 18" stroke="#fff" stroke-width="2" stroke-linecap="round"/>
        </svg>
      </div>
    </ng-container>

    <ng-container *ngIf="isSnappedLeft || isSnappedRight">
      <button class="unpin-button"
              (click)="unpin()"
              aria-label="Unpin dock"
              title="Unpin dock">
        <svg xmlns="http://www.w3.org/2000/svg" width="800px" height="800px" viewBox="0 0 24 24" fill="none" aria-hidden="true" focusable="false">
          <title>Unpin dock</title>
          <path d="M17.1218 1.87023C15.7573 0.505682 13.4779 0.76575 12.4558 2.40261L9.75191 6.73289L11.1969 8.17793C11.2355 8.1273 11.2723 8.07415 11.3071 8.01845L14.1523 3.46191C14.493 2.91629 15.2528 2.8296 15.7076 3.28445L20.6359 8.21274C21.0907 8.66759 21.0041 9.42737 20.4584 9.76806L15.9019 12.6133C15.8462 12.6481 15.793 12.6848 15.7424 12.7234L17.1874 14.1684L21.5177 11.4645C23.1546 10.4424 23.4147 8.16307 22.0501 6.79852L17.1218 1.87023Z" fill="#fff"/>
          <path d="M3.56525 8.85242C3.6015 8.26612 3.84962 7.68582 4.32883 7.27422L5.77735 8.72274C5.75784 8.72967 5.73835 8.7368 5.71886 8.74414C5.64516 8.7719 5.61855 8.80285 5.60548 8.82181C5.58877 8.84604 5.56651 8.8937 5.56144 8.97583C5.55046 9.15333 5.62872 9.40686 5.82846 9.6066L14.3137 18.0919C14.5135 18.2916 14.767 18.3699 14.9445 18.3589C15.0266 18.3538 15.0743 18.3316 15.0985 18.3149C15.1175 18.3018 15.1484 18.2752 15.1762 18.2015C15.1835 18.182 15.1907 18.1625 15.1976 18.143L16.6461 19.5915C16.2345 20.0707 15.6542 20.3188 15.0679 20.3551C14.2853 20.4035 13.4808 20.0874 12.8995 19.5061L9.36397 15.9705L2.68394 22.6506C2.29342 23.0411 1.66025 23.0411 1.26973 22.6506C0.879206 22.26 0.879206 21.6269 1.26973 21.2363L7.94975 14.5563L4.41425 11.0208C3.83293 10.4395 3.51687 9.63502 3.56525 8.85242Z" fill="#fff"/>
          <path d="M2.00789 2.00786C1.61736 2.39838 1.61736 3.03155 2.00789 3.42207L20.5862 22.0004C20.9767 22.3909 21.6099 22.3909 22.0004 22.0004C22.391 21.6099 22.391 20.9767 22.0004 20.5862L3.4221 2.00786C3.03158 1.61733 2.39841 1.61733 2.00789 2.00786Z" fill="#fff"/>
        </svg>
      </button>
    </ng-container>
  </div>
</div>

<!-- Screen reader only styles -->
<style>
.sr-only {
  position: absolute;
  width: 1px;
  height: 1px;
  padding: 0;
  margin: -1px;
  overflow: hidden;
  clip: rect(0, 0, 0, 0);
  white-space: nowrap;
  border: 0;
}
</style>
